<template>
<div v-if="inputValue && spans">
  <!-- 朝夕通し時間枠 -->

  <div class="my-8">
    <h5>延長パターン名</h5>
    <v-text-field
      v-model="inputValue.patternTitle"
      variant="outlined"
      hide-details
      density="compact"
    ></v-text-field>
  </div>

  <div>
    <div class="my-8">
      <h5>標準保育 開始時刻</h5>
      <time-input
        :hour="inputValue.normalChildcareStartingHour"
        @hour="inputValue.normalChildcareStartingHour = Number($event)"
        :minute="inputValue.normalChildcareStartingMinute"
        @minute="inputValue.normalChildcareStartingMinute = Number($event)"
      ></time-input>
    </div>

    <div class="my-8">
      <h5>短時間保育 開始時刻</h5>
      <time-input
        :hour="inputValue.shortenedChildcareStartingHour"
        @hour="inputValue.shortenedChildcareStartingHour = Number($event)"
        :minute="inputValue.shortenedChildcareStartingMinute"
        @minute="inputValue.shortenedChildcareStartingMinute = Number($event)"
      ></time-input>
    </div>

  </div>

  <!-- 時間枠（標準保育） -->
  <div v-for="(item, i) in spans.spans" :key="i">
    <div class="menu-header">標準延長時間{{i+1}}</div>

    <div class="my-8">
      <!-- <div>
        <h5>開始時刻</h5>
        <time-input
          :hour="item.startingHour"
          @hour="item.startingHour = Number($event)"
          :minute="item.startingMinute"
          @minute="item.startingMinute = Number($event)"
        ></time-input>
      </div>

      <div class="mt-4">
        <h5>終了時刻</h5>
        <time-input
          :hour="item.endingHour"
          @hour="item.endingHour = Number($event)"
          :minute="item.endingMinute"
          @minute="item.endingMinute = Number($event)"
        ></time-input>
      </div> -->

      <div class="my-8">
        <billing-input
          :hideMonthly="true"
          :billingMethod="item.billingMethod"
          @billingMethod="item.billingMethod = $event"
          :hourly="item.hourly"
          @hourly="item.hourly = $event"
          :monthly="item.monthly"
          @monthly="item.monthly = $event"
        ></billing-input>
      </div>
    </div>

  </div>

  <div class="d-flex">
    <v-btn
      @click="addSpanRow('normal')"
      color="primary"
      variant="outlined"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </div>

  <div class="my-12 d-flex justify-center">
    <v-btn
      @click="updatePattern"
      v-if="isUpdatable"
      :loading="isLoading"
      color="primary"
      variant="flat"
      large
    >保存</v-btn>
    <v-btn
      @click="createPattern"
      v-else
      :loading="isLoading"
      color="primary"
      variant="flat"
      large
    >作成</v-btn>
  </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { CreateSpotCombinationInput, nurseryHoursModule, CreateSpansInput } from '@/store/dataModules/nurseryHoursModule';
import Swal from 'sweetalert2';
import LocalDataService from '@/service/LocalDataService';
import TimeInput from '@/components/organisms/nursery-hours/TimeInput.vue'
import BillingInput from '@/components/organisms/nursery-hours/BillingInput.vue';

export default defineComponent({
  name: 'SpotCombinationPatternContainer',

  components: {
    TimeInput,
    BillingInput,
  },

  mounted() {
    if (!this.isUpdatable) {
      this.initValues();
      this.initSpans();
      this.addSpanRow();
    }
  },

  data() {
    return {
      isLoading: false,
    }
  },

  computed: {
    inputValue: {
      get(): CreateSpotCombinationInput | null {
        return nurseryHoursModule.spotCombinationPatternInput;
      },
      set(value: CreateSpotCombinationInput) {
        nurseryHoursModule.setSpotCombinationPatternInput(value);
      }
    },
    isUpdatable: function(): boolean {
      return (this.$route.query && this.$route.query.category != null); 
    },
    spans: {
      get(): CreateSpansInput | null {
        return nurseryHoursModule.spansInput;
      },
      set(value: CreateSpansInput) {
        nurseryHoursModule.setSpansInput(value);
      }
    },
  },

  methods: {
    initValues() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        this.inputValue = {
          nurseryId: nurseryId,
          patternTitle: '延長パターン',
          normalChildcareStartingHour: 8,
          normalChildcareStartingMinute: 0,
          shortenedChildcareStartingHour: 18,
          shortenedChildcareStartingMinute: 0,
        };
      }
    },
    async createPattern() {
      this.isLoading = true;
      const response = await nurseryHoursModule.createSpotCombinationPattern()
        .catch((e) => {
          alert("パターンの設定に失敗しました");
        });
      if (response) {
        if (response.patternId) {
          await this.createSpans(response.patternId)
            .catch();
        }
        Swal.fire({
          text: '作成しました',
        });
        this.$router.push({ path: '/nursery-hours' });
      }
      this.isLoading = false;
    },
    async updatePattern() {
      this.isLoading = true;
      const patternId = this.$route.query?.patternId;
      if (patternId) {
        const response = await nurseryHoursModule.updateSpotCombinationPattern({
          patternId: String(patternId),
        })
        .catch((e) => {
          alert("パターンの設定に失敗しました");
        });
        if (response) {
          if (response.patternId) {
            await this.updateSpans(response.patternId);
          }
          Swal.fire({
            title: '保存しました',
          });
        this.$router.push({ path: '/nursery-hours' });
        }
      }
      this.isLoading = false;
    },
    async createSpans(patternId: string) {
      if (patternId && nurseryHoursModule.spansInput) {
        nurseryHoursModule.spansInput.patternId = patternId;
        await nurseryHoursModule.saveSpans()
        .catch((e) => {
          alert("不正な値が入力されています。時間枠の設定を見直して再度行ってください");
        });
      }
    },
    async updateSpans(patternId: string) {
      if (patternId && nurseryHoursModule.spansInput) {
        nurseryHoursModule.spansInput.patternId = patternId;
        await nurseryHoursModule.updateSpans()
        .catch((e) => {
          alert("不正な値が入力されています。時間枠の設定を見直して再度行ってください");
        });
      }
    },
    initSpans() {
      this.spans = {
        patternId: '0',
        spans: [],
        spanCategory: 'normal',
      }
    },
    addSpanRow(category?: string) {
      if (this.spans) {
        if (category) {
          this.spans.spanCategory = category;
        }
        this.spans.spans.push({
          startingHour: 18,
          startingMinute: 0,
          endingHour: 18,
          endingMinute: 59,
          billingMethod: 'hourly',
          hourly: {
            billingMinute: 30,
            billingAmount: 100,
            billingUpperLimitAmount: 1000,
          },
          monthly: {
            billingAmount: 100,
          }
        });
      }
    },
  }
})
</script>